export const contratistas = [
    
			{
				"nombre": "Requisitos Contratista Inscripción",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/interes/REQUISITOS CONTRATISTA INSCRIPCION.pdf"
			},
			{
					"nombre": "Requisitos Contratista Ampliación",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
						 "url" : "/interes/REQUISITOS CONTRATISTA AMPLIACION.pdf"
				},
				{
					"nombre": "Requisitos Contratista Revalidación",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
					"url" : "/interes/REQUISITOS CONTRATISTA REVALIDACION.pdf"
				},
				{
			"nombre": "Aviso de Privacidad simplificado",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/Aviso de Privacidad Simplificado.docx"
			},

			{
			"nombre": "Carta bajo protesta de decir verdad",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CARTA BAJO PROTESTA DE DECIR VERDAD.docx"
			},

			{
			"nombre": "Captura de datos.",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CAPTURA DE DATOS IPPCEH DGN.docx"
			}
			


			
		

]